// Path: ./src/utils/IsAuthenticated/index.tsx
import { useContext } from "react";
import { GoFlyerAdminContext } from "../../contextApi/context";
import { SUPERADMIN } from "../../utils/constant/stringConstant";

export const IsAuthenticated = () => {
  const { state } = useContext(GoFlyerAdminContext);

  const isLoggedIn = state.user?.isLoggedIn; //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) there are many condition to check here. for example, if there is no token, if there is no user object, all log them out
  if (isLoggedIn) {
    return true;
  }
  return false;
};

export const verifyRole = (groupName: string, roleName: string) => {
  const { state } = useContext(GoFlyerAdminContext);
  const roleObject = state.user?.parsedRoles;
  if (roleObject?.name === SUPERADMIN) {
    return true;
  }
  if (roleObject?.name) {
    const group = roleObject?.permissions.find(
      (val) => val.groupName.toLowerCase() === groupName.toLowerCase()
    );

    if (group?.permissions?.length) {
      const permission = group?.permissions.find((val) => {
        return val.name === roleName;
      });
      if (permission?.allowed) {
        return true;
      }
      return false;
    }
    return false;
  }
  return false;
};
